import { DigitGroup } from "./digit-group";
import { Language } from "./language";


export class HumanReadableInteger {
  private static And: { [id: number]: string; };
  private static Negative: { [id: number]: string; };
  private static NumberWords: NumberWord[];
  private static Zero: { [id: number]: string; };

  NumberWords = [
    new NumberWord(DigitGroup.Ones, Language.English, ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"]),
    new NumberWord(DigitGroup.Ones, Language.Persian, ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"]),
    new NumberWord(DigitGroup.Teens, Language.English, ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"]),
    new NumberWord(DigitGroup.Teens, Language.Persian, ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"]),
    new NumberWord(DigitGroup.Tens, Language.English, ["Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"]),
    new NumberWord(DigitGroup.Tens, Language.Persian, ["بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"]),
    new NumberWord(DigitGroup.Hundreds, Language.English, ["", "One Hundred", "Two Hundred", "Three Hundred", "Four Hundred", "Five Hundred", "Six Hundred", "Seven Hundred", "Eight Hundred", "Nine Hundred"]),
    new NumberWord(DigitGroup.Hundreds, Language.Persian, ["", "یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"]),
    new NumberWord(DigitGroup.Thousands, Language.English, [
      "", " Thousand", " Million", " Billion", " Trillion", " Quadrillion", " Quintillion", " Sextillian", " Septillion", " Octillion", " Nonillion", " Decillion", " Undecillion", " Duodecillion", " Tredecillion", " Quattuordecillion",
      " Quindecillion", " Sexdecillion", " Septendecillion", " Octodecillion", " Novemdecillion", " Vigintillion", " Unvigintillion", " Duovigintillion", " 10^72", " 10^75", " 10^78", " 10^81", " 10^84", " 10^87", " Vigintinonillion", " 10^93",
      " 10^96", " Duotrigintillion", " Trestrigintillion"]),
    new NumberWord(DigitGroup.Thousands, Language.Persian, [
      "", " هزار", " میلیون", " میلیارد", " تریلیون", " Quadrillion", " Quintillion", " Sextillian", " Septillion", " Octillion", " Nonillion", " Decillion", " Undecillion", " Duodecillion", " Tredecillion", " Quattuordecillion",
      " Quindecillion", " Sexdecillion", " Septendecillion", " Octodecillion", " Novemdecillion", " Vigintillion", " Unvigintillion", " Duovigintillion", " 10^72", " 10^75", " 10^78", " 10^81", " 10^84", " 10^87", " Vigintinonillion", " 10^93",
      " 10^96", " Duotrigintillion", " Trestrigintillion"])

  ];

  And = { [Language.English]: " ", [Language.Persian]: " و " };
  Negative = { [Language.English]: "Negative ", [Language.Persian]: "منفی " };
  Zero = { [Language.English]: "Zero", [Language.Persian]: "صفر" };

  private GetName(idx: number, language: Language, groupe: DigitGroup): string {
    return this.NumberWords.filter(x => x.Group == groupe && x.Language == language)[0].Names[idx];
  }

  NumberToText = (value: number, language: Language): string => {
    if (value === 0) {
      return this.Zero[language];
    }
    if (value < 0) {
      return (this.Negative[language] + this.NumberToText(value, language));
    }
    return this.Wordify(value, language, "", 0);
  }


  private Wordify(number: number, language: Language, leftDigitsText: string, thousands: number): string {
    if (number === 0) {
      return leftDigitsText;
    }
    let str = leftDigitsText;
    if (str.length > 0) {
      str = str + this.And[language];
    }
    if (number < 10) {
      str = str + this.GetName(number, language, DigitGroup.Ones);
    }
    else if (number < 20) {
      str = str + this.GetName((Math.floor(number - 10)), language, DigitGroup.Teens);
    }
    else if (number < 100) {
      str = str + this.Wordify(number % 10, language, this.GetName(((number / 10) - 2), language, DigitGroup.Tens), 0);
    }
    else if (number < 1000) {
      str = str + this.Wordify(number % 100, language, this.GetName((number / 100), language, DigitGroup.Hundreds), 0);
    }
    else {
      str = str + this.Wordify(number % 1000, language, this.Wordify(number / 1000, language, "", thousands + 1), 0);
    }
    if ((number % 1000) === 0) {
      return str;
    }
    return (str + this.GetName(thousands, language, DigitGroup.Thousands));
  }
}


class NumberWord {
  Group: DigitGroup;
  Language: Language;
  Names: string[];

  constructor(group: DigitGroup, language: Language, names: string[]) {
    this.Group = group;
    this.Language = language;
    this.Names = names;
  }
}
